import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface BrandLogoProps {
  to?: string;
  logoHeight?: number;
  showText?: boolean;
  textColor?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  to = '/',
  logoHeight = 36,
  showText = true,
  textColor = '#5b0f1e',
}) => {
  const logoCandidates = ['/maandvo-logo.png', '/maandvo-logo.jpg', '/logo.png', '/logo.jpg'];
  const [logoIndex, setLogoIndex] = useState(0);
  const [imageReady, setImageReady] = useState(true);

  const handleImageError = () => {
    if (logoIndex < logoCandidates.length - 1) {
      setLogoIndex((prev) => prev + 1);
      return;
    }
    setImageReady(false);
  };

  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1.25,
        textDecoration: 'none',
      }}
    >
      {imageReady ? (
        <Box
          component="img"
          src={logoCandidates[logoIndex]}
          alt="Maandvo Matrimony"
          onError={handleImageError}
          sx={{
            height: logoHeight,
            width: 'auto',
            display: 'block',
            borderRadius: 1.25,
          }}
        />
      ) : null}

      {showText && (
        <Typography
          variant="subtitle1"
          sx={{
            fontFamily: "'Georgia', 'Times New Roman', serif",
            fontWeight: 800,
            letterSpacing: 0.6,
            color: textColor,
            lineHeight: 1,
          }}
        >
          MAANDVO
        </Typography>
      )}
    </Box>
  );
};

export default BrandLogo;
